module.exports = __webpack_public_path__ + "328c05f83094b98fa8befdfb58162ff0.svg";